import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import DatePicker from "components/DatePicker";
import { FormField } from "components/Form";
import Input from "components/Input";

import { usePatientForm } from "./usePatientForm";

export default function PatientForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  usePatientForm();

  return (
    <div className="flex flex-col gap-3.5 w-full">
      <FormField
        control={control}
        name="firstName"
        render={({ field }) => (
          <Input
            {...field}
            label={t("session.patientInformation.firstName")}
            placeholder={t("session.patientInformation.firstName")}
          />
        )}
      />
      <FormField
        control={control}
        name="lastName"
        render={({ field }) => (
          <Input
            {...field}
            label={t("session.patientInformation.lastName")}
            placeholder={t("session.patientInformation.lastName")}
          />
        )}
      />

      <FormField
        control={control}
        name="identificationNumber"
        render={({ field }) => (
          <Input
            {...field}
            label={t("session.patientInformation.identificationNumber")}
            placeholder={t("session.patientInformation.identificationNumber")}
          />
        )}
      />

      <FormField
        control={control}
        name="birthDate"
        render={({ field }) => <DatePicker {...field} label={t("session.patientInformation.birthDate")} />}
      />

      <FormField
        control={control}
        name="phone"
        render={({ field }) => (
          <Input
            {...field}
            type="number"
            label={t("session.patientInformation.phone")}
            placeholder={t("session.patientInformation.phone")}
          />
        )}
      />
      <FormField
        control={control}
        name="address"
        render={({ field }) => (
          <Input
            {...field}
            label={t("session.patientInformation.address")}
            placeholder={t("session.patientInformation.address")}
          />
        )}
      />
      <FormField
        control={control}
        name="email"
        render={({ field }) => (
          <Input
            {...field}
            type="email"
            label={t("session.patientInformation.email")}
            placeholder={t("session.patientInformation.email")}
          />
        )}
      />
    </div>
  );
}
